module.exports = __webpack_public_path__ + "static/media/dateconverter.f6c4cb73.svg";